import PropTypes from 'prop-types';

const defaultProps = {};

const propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default function TrainerPageSection({ title, children }) {
  return (
    <div className="space-y-4 lg:space-y-6">
      <h3 className="font-semibold text-xl lg:text-2xl xl:text-3xl lg:tracking-tight">
        {title}
      </h3>
      <div className="w-full">{children}</div>
    </div>
  );
}

TrainerPageSection.defaultProps = defaultProps;
TrainerPageSection.propTypes = propTypes;
